module.exports = __webpack_public_path__ + "static/img/2.184cf41.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/2.png
// module id = 2NXg
// module chunks = 0